define([
    "./tripPickingListService",
    "./tripPickingListServiceUrl",
    "./tripPickingListServiceDependencies",
    "./tripPickingListServiceImages",
    "./tripPickingListModule",
], function () {
});